import React, { Fragment } from 'react';
import Api from 'Api';
import ReactDOM from 'react-dom';
import { I18nextProvider, translate } from 'react-i18next';
import i18n from '../locale';
import axios from 'axios';
import Spinner from '../components/spinner';

const api = `${process.env.API_ENDPOINT}/api/v2`;

class Outlets extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			outlets: [],
			categories: [],
			selectedCategory: '',
			page: 1,
			loading: false,
			maxPage: false,
			searchQuery: '',
			searchState: '',
			loadingList: true,
			noData: false,
		};
	}
	componentDidMount() {
		axios.get(api + '/categories').then((res) => {
			this.setState({ categories: res.data.data });
		});
		axios.get(api + '/outlets', { params: { limit: 18, sort: 'id' } }).then((res) => {
			this.setState({ outlets: res.data.data, loadingList: false });
		});
	}
	showMore = () => {
		this.setState({ loading: true, page: this.state.page + 1 }, () => {
			var category = this.state.selectedCategory;
			axios
				.get(api + '/outlets', {
					params: { category, limit: 18, page: this.state.page, sort: 'id', q: this.state.searchState },
				})
				.then((res) => {
					var maxPage = res.data.data.length < 18;
					this.setState({
						loading: false,
						maxPage,
						loadingList: false,
						outlets: [...this.state.outlets, ...res.data.data],
					});
				});
		});
	};
	onChange = (e) => {
		this.setState({ [e.target.id]: e.target.value });
		if (e.target.id == 'selectedCategory') {
			this.setState({ loadingList: true }, () => {
				axios
					.get(api + '/outlets', {
						params: {
							category: this.state.selectedCategory,
							limit: 18,
							sort: 'id',
							q: this.state.searchState,
						},
					})
					.then((res) => {
						var maxPage = res.data.data.length < 18;
						var noData = res.data.data.length < 1;
						this.setState({ outlets: res.data.data, maxPage, noData, loadingList: false });
					});
			});
		} else {
		}
	};
	onSearch = (e) => {
		e.preventDefault();
		this.setState({ searchState: this.state.searchQuery, loadingList: true }, () => {
			axios
				.get(api + '/outlets', { params: { limit: 18, sort: 'id', q: this.state.searchState } })
				.then((res) => {
					var maxPage = res.data.data.length < 18;
					var noData = res.data.data.length < 1;
					this.setState({ outlets: res.data.data, maxPage, noData, loadingList: false });
				});
		});
	};
	render() {
		const {
			noData,
			outlets,
			categories,
			selectedCategory,
			loading,
			maxPage,
			searchQuery,
			loadingList,
		} = this.state;
		const { t } = this.props;
		return (
			<Fragment>
				<section className="section-search">
					<div className="container">
						<div className="row">
							<div className="col-lg-3">
								<select
									onChange={this.onChange}
									name="category"
									value={selectedCategory}
									id="selectedCategory"
								>
									<option value="">Semua Kategori</option>
									{categories.map((val) => {
										return (
											<option value={val.id} key={`category${val.id}`}>
												{val.name}
											</option>
										);
									})}
								</select>
							</div>
							<div className="col-lg-9 d-flex">
								<form className="d-flex w-100">
									<input type="submit" value="" onClick={this.onSearch} />
									<input type="text" value={searchQuery} onChange={this.onChange} id="searchQuery" />
								</form>
							</div>
						</div>
					</div>
				</section>
				<section className="section-outlet">
					{noData ? (
						<div className="loading-list">
							<h2>Oops!</h2>
							<h4>We could not find the outlet you are looking for!</h4>
						</div>
					) : loadingList ? (
						<div className="loading-list">
							<Spinner size={100} color={'#000'} />
						</div>
					) : (
						<Fragment>
							<div className="container outlet-list">
								{outlets.map((val) => {
									return (
										<a
											href={`/outlet/${val.slug}`}
											key={`outlets${val.id}`}
											id={`outlets${val.id}`}
										>
											<div className="col-3">
												<img
													src={
														val.image_logo ? val.image_logo : `/assets/img/icon/outlet.png`
													}
												/>
											</div>
											<div className="col-9">
												<p>{val.name}</p>
												<p>
													{Array.isArray(val.categories)
														? val.categories.map((value, idx) => {
																if (idx == 0) {
																	return value.name ? value.name : '';
																}
														  })
														: ''}
												</p>
											</div>
										</a>
									);
								})}
							</div>
							{maxPage ? (
								<div className="p-90"></div>
							) : loading ? (
								<div className="p-90">
									<Spinner size={50} color={'#000'} />
								</div>
							) : (
								<button onClick={this.showMore}>SHOW MORE</button>
							)}
						</Fragment>
					)}
				</section>
			</Fragment>
		);
	}
}

const Translated = translate('translation')(Outlets);

document.getElementById('outlets-react')
	? ReactDOM.render(
			<I18nextProvider i18n={i18n}>
				<Translated />
			</I18nextProvider>,
			document.getElementById('outlets-react')
	  )
	: '';



// WEBPACK FOOTER //
// ./assets/js/outlets/index.js